import * as types from '../action-types';
import { storeSelectionId } from './decisionSelection';

type openProps = {
  top: number;
  left: number;
};

export const openActionSidebarRemovePopover = (data: openProps) =>
  <const>{
    type: types.openActionSidebarRemovePopover,
    payload: { data },
  };

export const closeActionSidebarRemovePopover = () => {
  return <const>{
    type: types.closeActionSidebarRemovePopover,
  };
};

export const checkCloseActionSidebarRemovePopover = () => (
  dispatch: Function,
  getState: Function,
) => {
  const {
    decision: { actionSidebarRemove },
  } = getState();
  if (actionSidebarRemove.isOpen) {
    dispatch(closeActionSidebarRemovePopover());
    dispatch(storeSelectionId(null));
  }
};

export type ActionSidebarRemoveActions = ReturnType<
  typeof openActionSidebarRemovePopover | typeof closeActionSidebarRemovePopover
>;
